const defaultTableLengthIAM =
  document.getElementById('view-data:TableLengthIAM') !== null
    ? document.getElementById('view-data:TableLengthIAM').value
    : 5; // need to catch text values this way

export default {
  install(Vue) {
    Vue.prototype.tableLengthIAM = parseInt(defaultTableLengthIAM) || 25;
  },
  defaultTableLengthIAM,
};
